import { ApproveJoinRequestRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/team/join-requests/$requestId')({
  component: ApproveJoinRequestRoute,
});
